import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

  @NgModule({
    imports: [
      RouterModule.forRoot(
        routes, {
          onSameUrlNavigation: 'reload',
          scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule],
    providers: [
          ]
  })
  export class AppRoutingModule {}
